import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  FormControl,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  Checkbox,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EmailIcon from "@mui/icons-material/Email";

// QRコード生成
import { QRCodeCanvas } from "qrcode.react";

// InterFace
import { TableColumn } from "../config/dataInterface";
import { useWindowSize } from "../lib/useWindowSize";

// API
import { getContractProduct } from "../api/contract";
import { getAddress } from "../api/address";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../api/presignedURL";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface InputFreeTextProps {
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    phone_number: string;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "sms_success";
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      productId: number | null;
      productName: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      phone_number: string;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOption: { [key: string]: string | number | string[] };
  addressOptionName: string;
}

function InputFreeText(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <CustomTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        size="small"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        sx={{
          width: "calc(100% - 10px)",
          margin: "10px 5px",
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.change_value_conf !== 1 ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            marginRight: "5px",
            height: "25px",
          }}
        >
          {addData.outSiteEntry === 0
            ? uniqueOption.required_optional === 1
              ? "※必須"
              : "※任意"
            : addData.outSiteEntry === 1
              ? (addData.outsideMessageType === 0 &&
                  uniqueOption.tel_flg === 1) ||
                (addData.outsideMessageType === 1 &&
                  uniqueOption.mail_address_flg === 1)
                ? "※必須"
                : uniqueOption.outside_form_display === 1
                  ? "外部ET非表示"
                  : undefined
              : undefined}
        </FormHelperText>
      ) : null}
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextHalfWidthNumber(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption } = props;
  return (
    <>
      <CustomTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        size="small"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          const inputValue = e.target.value;
          if (!/^\d*$/.test(inputValue)) return;
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = inputValue;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
        sx={{
          width: "calc(100% - 10px)",
          margin: "10px 5px",
        }}
      />
      {uniqueOption.change_value_conf !== 1 ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            marginRight: "5px",
            height: "25px",
          }}
        >
          {addData.outSiteEntry === 0
            ? uniqueOption.required_optional === 1
              ? "※必須"
              : "※任意"
            : addData.outSiteEntry === 1
              ? (addData.outsideMessageType === 0 &&
                  uniqueOption.tel_flg === 1) ||
                (addData.outsideMessageType === 1 &&
                  uniqueOption.mail_address_flg === 1)
                ? "※必須"
                : uniqueOption.outside_form_display === 1
                  ? "外部ET非表示"
                  : undefined
              : undefined}
        </FormHelperText>
      ) : null}
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      const phone_number = input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        phone_number,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdTel1"
          size="small"
          value={input1}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel2"
          size="small"
          value={input2}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel3"
          size="small"
          value={input3}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {addData.outSiteEntry === 0
          ? uniqueOption.required_optional === 1
            ? "※必須"
            : "※任意"
          : addData.outSiteEntry === 1
            ? (addData.outsideMessageType === 0 &&
                uniqueOption.tel_flg === 1) ||
              (addData.outsideMessageType === 1 &&
                uniqueOption.mail_address_flg === 1)
              ? "※必須"
              : uniqueOption.outside_form_display === 1
                ? "外部ET非表示"
                : undefined
            : undefined}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextFormTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdTel1"
          size="small"
          value={input1}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel2"
          size="small"
          value={input2}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel3"
          size="small"
          value={input3}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {addData.outSiteEntry === 0
          ? uniqueOption.required_optional === 1
            ? "※必須"
            : "※任意"
          : addData.outSiteEntry === 1
            ? (addData.outsideMessageType === 0 &&
                uniqueOption.tel_flg === 1) ||
              (addData.outsideMessageType === 1 &&
                uniqueOption.mail_address_flg === 1)
              ? "※必須"
              : uniqueOption.outside_form_display === 1
                ? "外部ET非表示"
                : undefined
            : undefined}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      const customer_name = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customer_name,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdName1"
          size="small"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "5px" }} />
        <CustomTextField
          id="textFieldIdName2"
          size="small"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {addData.outSiteEntry === 0
          ? uniqueOption.required_optional === 1
            ? "※必須"
            : "※任意"
          : addData.outSiteEntry === 1
            ? (addData.outsideMessageType === 0 &&
                uniqueOption.tel_flg === 1) ||
              (addData.outsideMessageType === 1 &&
                uniqueOption.mail_address_flg === 1)
              ? "※必須"
              : uniqueOption.outside_form_display === 1
                ? "外部ET非表示"
                : undefined
            : undefined}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextCompanyName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <CustomTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        size="small"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          const customer_company_name = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            customer_company_name,
          }));
        }}
        sx={{
          width: "calc(100% - 10px)",
          margin: "10px 5px",
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.change_value_conf !== 1 ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            marginRight: "5px",
            height: "25px",
          }}
        >
          {addData.outSiteEntry === 0
            ? uniqueOption.required_optional === 1
              ? "※必須"
              : "※任意"
            : addData.outSiteEntry === 1
              ? (addData.outsideMessageType === 0 &&
                  uniqueOption.tel_flg === 1) ||
                (addData.outsideMessageType === 1 &&
                  uniqueOption.mail_address_flg === 1)
                ? "※必須"
                : uniqueOption.outside_form_display === 1
                  ? "外部ET非表示"
                  : undefined
              : undefined}
        </FormHelperText>
      ) : null}
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextZipCode(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = zipCode;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));

      const address = await getAddress(zipCode);
      customerInfo[addressOptionName] = address;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const zipCode = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(zipCode);
      } else {
        let customerInfo = addData.customerInfo;
        customerInfo[uniqueOption.option_name as string] = zipCode;
        setAddData((addData) => ({
          ...addData,
          customerInfo,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdZipCode1"
          size="small"
          value={input1}
          inputProps={{ maxLength: 3 }}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
              setInput1(inputValue);
            }
          }}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdZipCode2"
          size="small"
          value={input2}
          inputProps={{ maxLength: 4 }}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 4) {
              setInput2(inputValue);
            }
          }}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {addData.outSiteEntry === 0
          ? uniqueOption.required_optional === 1
            ? "※必須"
            : "※任意"
          : addData.outSiteEntry === 1
            ? (addData.outsideMessageType === 0 &&
                uniqueOption.tel_flg === 1) ||
              (addData.outsideMessageType === 1 &&
                uniqueOption.mail_address_flg === 1)
              ? "※必須"
              : uniqueOption.outside_form_display === 1
                ? "外部ET非表示"
                : undefined
            : undefined}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextSpace(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdSpace1"
          size="small"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "5px" }} />
        <CustomTextField
          id="textFieldIdSpace2"
          size="small"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {addData.outSiteEntry === 0
          ? uniqueOption.required_optional === 1
            ? "※必須"
            : "※任意"
          : addData.outSiteEntry === 1
            ? (addData.outsideMessageType === 0 &&
                uniqueOption.tel_flg === 1) ||
              (addData.outsideMessageType === 1 &&
                uniqueOption.mail_address_flg === 1)
              ? "※必須"
              : uniqueOption.outside_form_display === 1
                ? "外部ET非表示"
                : undefined
            : undefined}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextMailAddress(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + "@" + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdmm1"
          size="small"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          @
        </Box>
        <CustomTextField
          id="textFieldIdmm2"
          size="small"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {addData.outSiteEntry === 0
          ? uniqueOption.required_optional === 1
            ? "※必須"
            : "※任意"
          : addData.outSiteEntry === 1
            ? (addData.outsideMessageType === 0 &&
                uniqueOption.tel_flg === 1) ||
              (addData.outsideMessageType === 1 &&
                uniqueOption.mail_address_flg === 1)
              ? "※必須"
              : uniqueOption.outside_form_display === 1
                ? "外部ET非表示"
                : undefined
            : undefined}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

interface ContractAddModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  tableColumn: TableColumn;
  postAddData: (customerInfo: { [key: string]: string | string[] }) => void;
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "entry_method"
        | "site_path"
        | "contract"
        | "sms_success";
      outSiteEntry: 0 | 1;
      outsideSiteUrl: string;
      outsideServiceUrl: string;
      viewOutsideServiceUrl: 0 | 1;
      productId: number | null;
      productName: string;
      have_entry_form: number | null;
      site_path_list: string[];
      site_path: string;
      outsideMessageType: number | null;
      phone_number: string;
      customer_name: string;
      customer_company_name: string;
      servicePlanName: string;
      serviceContentNameList: string[];
      serviceCampaignPulldownName: string;
      serviceCampaignCheckboxName: string[];
      servicePaymentMethodName: string;
      serviseCustomerListID: string;
      pullDownServiceName: string;
      checkBoxServiceNames: string;
      smsMessagePatternID: number | null;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  contractProductList: {
    id: number;
    product_name: string;
    have_entry_form: number;
    site_path_list: string[];
  }[];
  firstYear: number;
  thisYear: number;
  selectServisePlanList: { service_name: string }[];
  setSelectServisePlanList: (value: { service_name: string }[]) => void;
  selectServiseContentList: { service_name: string }[];
  setSelectServiseContentList: (value: { service_name: string }[]) => void;
  selectServiseCampaignPulldownList: { service_name: string }[];
  setSelectServiseCampaignPulldownList: (
    value: { service_name: string }[],
  ) => void;
  selectServiseCampaignCheckboxList: { service_name: string }[];
  setSelectServiseCampaignCheckboxList: (
    value: { service_name: string }[],
  ) => void;
  selectServisePaymentList: { payment_method: string }[];
  setSelectServisePaymentList: (value: { payment_method: string }[]) => void;
  uniqueOptinList: { [key: string]: string | number | string[] }[];
  setUniqueOptinList: (
    value: { [key: string]: string | number | string[] }[],
  ) => void;
  addressOptionName: string;
  setAddressOptionName: (name: string) => void;
  postPictures: {
    [key: string]: File;
  };
  setPostPicture: (value: { [key: string]: File }) => void;
  setOnDataAddModalResult: (value: string) => void;
}

export function ContractAddModal(props: ContractAddModalProps) {
  const {
    onModal,
    swCloseModal,
    tableColumn,
    postAddData,
    addData,
    setAddData,
    contractProductList,
    firstYear,
    thisYear,
    selectServisePlanList,
    setSelectServisePlanList,
    selectServiseContentList,
    setSelectServiseContentList,
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
    selectServisePaymentList,
    setSelectServisePaymentList,
    uniqueOptinList,
    setUniqueOptinList,
    addressOptionName,
    setAddressOptionName,
    postPictures,
    setPostPicture,
    setOnDataAddModalResult,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const loginUser = useAtomValue(AppAtoms.loginUser);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // 商材一覧検索用
  const [inputSerchProductName, setInputSerchProductName] = useState("");
  const [serchProductList, setSerchProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);
  useEffect(() => {
    if (inputSerchProductName === "") {
      const serchProductList = contractProductList.filter(
        (product) =>
          product.have_entry_form === 1 || product.site_path_list.length > 0,
      );
      setSerchProductList(serchProductList);
    } else {
      const serchProductList = contractProductList.filter(
        (product) =>
          (product.have_entry_form === 1 ||
            product.site_path_list.length > 0) &&
          product.product_name.includes(inputSerchProductName),
      );
      setSerchProductList(serchProductList);
    }
  }, [contractProductList, inputSerchProductName]);

  // 外部ET用の変数
  const [outSidePullDownServiceNameList, setOutSidePullDownServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [outSideCheckBoxServiceNameList, setOutSideCheckBoxServiceNameList] =
    useState<{ service_name: string }[]>([]);
  const [smsMessagePatterns, setSmsMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_body: string;
    }[]
  >([]);
  const [mailMessagePatterns, setMailMessagePatterns] = useState<
    {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_title: string;
      outside_sms_body: string;
    }[]
  >([]);

  const [useMailAddressFlg, setUseMailAddressFlg] = useState(false);

  async function getProductInfo(
    productId: number,
    productName: string,
    outSiteEntry: 0 | 1,
    site_path: string,
  ) {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    const {
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      service_payment_data,
      option_data,
      outside_pull_down_service,
      outside_check_box_service,
      outside_option_data,
      outside_sms_patterns,
      outside_mail_patterns,
    } = await getContractProduct(
      productId,
      outSiteEntry,
      site_path,
      addData.changeAccount,
      addData.changeAccountID,
    );
    if (outSiteEntry === 0) {
      // 内部エントリー
      if (service_plan_data.length === 0) {
        swCloseModal();
        setOnDataAddModalResult(
          "エントリー可能なプランが定義されていません。管理者に問い合わせてください。",
        );
      } else {
        setSelectServisePlanList(service_plan_data);
        setSelectServiseContentList(service_content_data);
        if (service_campaign_pulldown_data.length > 0) {
          setSelectServiseCampaignPulldownList([
            { service_name: "" },
            ...service_campaign_pulldown_data,
          ]);
        } else {
          setSelectServiseCampaignPulldownList(service_campaign_pulldown_data);
        }
        setSelectServiseCampaignCheckboxList(service_campaign_checkbox_data);
        setSelectServisePaymentList(service_payment_data);
        setUniqueOptinList(option_data);
        if (option_data.length > 0) {
          const customerInfo: {
            [key: string]: string | string[];
          } = option_data.reduce<{ [key: string]: string | string[] }>(
            (column, option) => {
              let option_value: string | string[] = "";
              if (option.option_type === 0) {
                option_value = option.option_default_value as string;
                return {
                  ...column,
                  [option.option_name as string]: option_value,
                };
              } else if (option.option_type === 1 || option.option_type === 4) {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else if (option.option_type === 3) {
                return {
                  ...column,
                  [option.option_name as string]: "",
                };
              } else {
                return {
                  ...column,
                  [option.option_name as string]: [],
                };
              }
            },
            {},
          );
          let addressOptionName = "";
          option_data.map((uniqueOptin) => {
            if (uniqueOptin.address_flg) {
              addressOptionName = uniqueOptin.option_name as string;
            }
          });
          setAddressOptionName(addressOptionName);
          setAddData((addData) => ({
            ...addData,
            customerInfo,
            addStatus: "contract",
            productId,
            productName,
            outSiteEntry,
          }));
        } else {
          swCloseModal();
          setOnDataAddModalResult(
            "エントリーフォームが定義されていません。管理者に問い合わせてください。",
          );
        }
      }
    } else if (outSiteEntry === 1) {
      // 外部エントリー
      setOutSidePullDownServiceNameList(outside_pull_down_service);
      setOutSideCheckBoxServiceNameList(outside_check_box_service);
      setSmsMessagePatterns(outside_sms_patterns);
      setMailMessagePatterns(outside_mail_patterns);
      if (outside_option_data.length > 0) {
        const customerInfo: {
          [key: string]: string | string[];
        } = outside_option_data.reduce<{ [key: string]: string | string[] }>(
          (column, option) => {
            let option_value: string | string[] = "";
            if (option.option_type === 0) {
              option_value = option.option_default_value as string;
              return {
                ...column,
                [option.option_name as string]: option_value,
              };
            } else if (option.option_type === 1 || option.option_type === 4) {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else if (option.option_type === 3) {
              return {
                ...column,
                [option.option_name as string]: "",
              };
            } else {
              return {
                ...column,
                [option.option_name as string]: [],
              };
            }
          },
          {},
        );
        let addressOptionName = "";
        let mail_address_flg_use = false;
        outside_option_data.map((uniqueOptin) => {
          if (uniqueOptin.address_flg) {
            addressOptionName = uniqueOptin.option_name as string;
          }
          if (uniqueOptin.mail_address_flg_use) {
            mail_address_flg_use = true;
          }
        });
        setUseMailAddressFlg(mail_address_flg_use);
        setUniqueOptinList(outside_option_data);
        setAddressOptionName(addressOptionName);
        setAddData((addData) => ({
          ...addData,
          customerInfo,
          addStatus: "contract",
          productId,
          productName,
          site_path,
          outSiteEntry,
        }));
      } else {
        swCloseModal();
        setOnDataAddModalResult(
          "外部ETフォームが定義されていません。管理者に問い合わせてください。",
        );
      }
    }
  }

  const [onPostBottun, setOnPostBottun] = useState(false);
  useEffect(() => {
    if (addData.addStatus !== null && addData.addStatus !== "loading") {
      let onPostBottun = true;
      // 内部エントリーの時のみ依存関係確認
      if (addData.outSiteEntry == 0) {
        uniqueOptinList.map((uniqueOptin) => {
          const service_plan_names = uniqueOptin.service_plan_names as string[];
          const service_content_names =
            uniqueOptin.service_content_names as string[];
          const depend_option_name = uniqueOptin.depend_option_name as string;
          const depend_select_names =
            uniqueOptin.depend_select_names as string[];
          const depend_option_value = addData.customerInfo[depend_option_name];
          if (
            uniqueOptin.required_optional === 1 &&
            (service_plan_names.length === 0 ||
              service_plan_names.includes(addData.servicePlanName)) &&
            (service_content_names.length === 0 ||
              service_content_names.some((item) =>
                addData.serviceContentNameList.includes(item),
              )) &&
            (depend_option_name === "他質問に依存しない" ||
              (typeof depend_option_value === "string" &&
                depend_select_names.includes(depend_option_value as string)) ||
              (typeof depend_option_value === "object" &&
                depend_select_names.some((item) =>
                  depend_option_value.includes(item),
                )))
          ) {
            if (
              uniqueOptin.option_type === 0 ||
              uniqueOptin.option_type === 1 ||
              uniqueOptin.option_type === 3
            ) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
              if (
                customerInfoValue === undefined ||
                customerInfoValue === "" ||
                customerInfoValue === " " ||
                customerInfoValue === "--"
              ) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 2) {
              const customerInfoValue = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string[];
              if (customerInfoValue.length === 0) {
                onPostBottun = false;
              }
            } else if (uniqueOptin.option_type === 4) {
              if (!postPictures[uniqueOptin.option_name as string]) {
                onPostBottun = false;
              }
            }
          }
        });

        if (addData.servicePlanName === "") {
          onPostBottun = false;
        }
        if (
          selectServisePaymentList.length > 0 &&
          addData.servicePaymentMethodName === ""
        ) {
          onPostBottun = false;
        }
      }

      // 外部ETフォーム
      if (addData.outSiteEntry == 1) {
        // SMS送信情報確認
        if (addData.outsideMessageType === null) {
          onPostBottun = false;
        }
        if (
          (addData.outsideMessageType === 0 ||
            addData.outsideMessageType === 1) &&
          addData.smsMessagePatternID === null
        ) {
          onPostBottun = false;
        }

        // SMS送信の場合は顧客電話番号の確認
        if (addData.outsideMessageType === 0) {
          if (addData.phone_number === "--") {
            onPostBottun = false;
          }
        }

        // メール送信の場合はメールアドレスの確認
        if (addData.outsideMessageType === 1) {
          let mail_address = "@";
          // そもそも質問にメールアドレスが定義されていない場合
          if (useMailAddressFlg === false) {
            mail_address = addData.customerInfo["メールアドレス"] as string;
          }
          uniqueOptinList.map((uniqueOptin) => {
            if (uniqueOptin.mail_address_flg === 1) {
              mail_address = addData.customerInfo[
                uniqueOptin.option_name as string
              ] as string;
            }
          });
          if (mail_address === "@") {
            onPostBottun = false;
          }
        }
      }

      setOnPostBottun(onPostBottun);
    }
  }, [addData, postPictures]);

  // 契約登録前に画像データ格納
  async function postAddContractData() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    let customerInfo = { ...addData.customerInfo };
    await Promise.all(
      uniqueOptinList.map(async (uniqueOption) => {
        if (
          uniqueOption.option_type === 4 &&
          postPictures[uniqueOption.option_name as string]
        ) {
          const postPicture = postPictures[uniqueOption.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", postPicture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          customerInfo[uniqueOption.option_name as string] = destination_key;
        }
      }),
    );
    await postAddData(customerInfo);
  }

  return addData.addStatus !== null && addData.addStatus !== "loading" ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} key="ContractAddModalBox">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          {tableColumn.addTitle}
        </Box>
        {addData.addStatus === "product" ? (
          <>
            <Box className="serch-label">
              商材検索（部分一致）
              <Box key="searchProductName">
                <CustomTextField
                  id="inputSerchProductName"
                  size="small"
                  value={inputSerchProductName}
                  onChange={async (e) => {
                    setInputSerchProductName(e.target.value);
                  }}
                  sx={{
                    width: "calc(100% - 10px)",
                    margin: "10px 5px",
                  }}
                />
              </Box>
            </Box>
          </>
        ) : null}
        {addData.addStatus === "entry_method" ? (
          <Box className="serch-label">エントリー方法</Box>
        ) : null}
        {addData.addStatus === "site_path" ? (
          <Box className="serch-label">サイトパス</Box>
        ) : null}
        {addData.addStatus === "product" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 0,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 100px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
            key="ContractAddModalBoxProject"
          >
            <Paper elevation={0}>
              <Box
                key="shozai1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 150px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box
                  key="shozaiClick"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {serchProductList.map((product, i) => {
                    return (
                      <Box
                        style={{
                          marginTop: "10px",
                          height: "40px",
                          width:
                            windowWidth > 385
                              ? "calc(50% - 5px)"
                              : "calc(100% - 10px)",
                          marginLeft:
                            windowWidth > 385 && i % 2 !== 0 ? "10px" : "0",
                        }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            height: "40px",
                            width: "100%",
                            textTransform: "none",
                          }}
                          onClick={async () => {
                            const productId = product.id;
                            const productName = product.product_name;
                            const have_entry_form = product.have_entry_form;
                            const site_path_list = product.site_path_list;
                            if (site_path_list.length > 0) {
                              setAddData((addData) => ({
                                ...addData,
                                addStatus: "entry_method",
                                productId,
                                productName,
                                have_entry_form,
                                site_path_list,
                              }));
                            } else {
                              await getProductInfo(
                                productId,
                                productName,
                                0,
                                "",
                              );
                            }
                          }}
                        >
                          <Box className="m-plus-rounded-1c-regular">
                            {product.product_name}
                          </Box>
                        </Button>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
            <Box
              key="shozaiSelect"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "20px",
                  height: "40px",
                  width: "calc(100% - 10px)",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    swCloseModal();
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : addData.addStatus === "entry_method" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box
                  key="shozaiClick"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: "0px",
                    }}
                  >
                    <Button
                      disabled={addData.have_entry_form === 0}
                      variant="contained"
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={async () => {
                        await getProductInfo(
                          addData.productId as number,
                          addData.productName,
                          0,
                          "",
                        );
                      }}
                    >
                      <Box className="m-plus-rounded-1c-regular">
                        エントリー
                      </Box>
                    </Button>
                  </Box>
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={async () => {
                        if (addData.site_path_list.length === 1) {
                          await getProductInfo(
                            addData.productId as number,
                            addData.productName,
                            1,
                            addData.site_path_list[0],
                          );
                        } else {
                          setAddData((addData) => ({
                            ...addData,
                            addStatus: "site_path",
                          }));
                        }
                      }}
                    >
                      <Box className="m-plus-rounded-1c-regular">
                        外部URL作成
                      </Box>
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>
            <Box
              key="shozaiSelect"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "20px",
                  height: "40px",
                  width: "calc(100% - 10px)",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "product",
                    }));
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : addData.addStatus === "site_path" ? (
          <Typography
            key="ContractAddModalBoxContract_site_path"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1_site_path"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box
                  key="shozaiClick_site_path"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {addData.site_path_list.map((site_path, i) => {
                    return (
                      <Box
                        style={{
                          marginTop: "10px",
                          height: "40px",
                          width:
                            windowWidth > 385
                              ? "calc(50% - 5px)"
                              : "calc(100% - 10px)",
                          marginLeft:
                            windowWidth > 385 && i % 2 !== 0 ? "10px" : "0",
                        }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            height: "40px",
                            width: "100%",
                            textTransform: "none",
                          }}
                          onClick={async () => {
                            await getProductInfo(
                              addData.productId as number,
                              addData.productName,
                              1,
                              site_path,
                            );
                          }}
                        >
                          <Box className="m-plus-rounded-1c-regular">
                            {site_path}
                          </Box>
                        </Button>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
            <Box
              key="shozaiSelect"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "20px",
                  height: "40px",
                  width: "calc(100% - 10px)",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "entry_method",
                    }));
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : addData.addStatus === "contract" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box className="serch-label">
                  {addData.productName as string}
                </Box>
                <FormHelperText
                  id="serch-name"
                  sx={{
                    width: "calc(100% - 10px)",
                    textAlign: "right",
                    marginTop: "-8px",
                    height: "25px",
                  }}
                ></FormHelperText>
                {addData.outSiteEntry === 0 ? (
                  <>
                    <Box className="serch-label">プラン</Box>
                    <Box key="servicePlanBox">
                      <FormControl
                        fullWidth
                        sx={{
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "5px",
                          width: "calc(100% - 10px)",
                        }}
                      >
                        <Select
                          labelId="serch-input-label"
                          id="serch-input-option"
                          key={"servicePlanSelect"}
                          value={addData.servicePlanName}
                          onChange={(e) => {
                            const servicePlanName = e.target.value as string;
                            setAddData((addData) => ({
                              ...addData,
                              servicePlanName,
                            }));
                          }}
                          sx={{
                            height: "30px",
                            textAlign: "end",
                            fontSize: "14px",
                          }}
                        >
                          {selectServisePlanList.map((service, plan_i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuPlan" + plan_i}
                                value={service.service_name}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    service.service_name === ""
                                      ? "14px"
                                      : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {service.service_name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                    {selectServiseContentList.length > 0 ? (
                      <Box key="contractServiceContent">
                        <Box className="serch-label">コンテンツ</Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          {selectServiseContentList.map((service) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    addData.serviceContentNameList.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let serviceContentNameList =
                                      addData.serviceContentNameList.concat();

                                    if (
                                      addData.serviceContentNameList.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    ) {
                                      serviceContentNameList =
                                        serviceContentNameList.filter(
                                          (serviceName) =>
                                            serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      serviceContentNameList.push(
                                        service.service_name,
                                      );
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      serviceContentNameList,
                                    }));
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    ) : null}
                    {selectServiseCampaignPulldownList.length > 0 ? (
                      <Box key="serviceeCampaignPulldownLabelBox">
                        <Box className="serch-label">
                          {selectServiseCampaignCheckboxList.length > 0
                            ? "キャンペーン1"
                            : "キャンペーン"}
                        </Box>
                        <Box key="serviceeCampaignPulldownBox">
                          <FormControl
                            fullWidth
                            sx={{
                              marginTop: "10px",
                              marginBottom: "20px",
                              marginLeft: "5px",
                              width: "calc(100% - 10px)",
                            }}
                          >
                            <Select
                              labelId="serch-input-label"
                              id="serch-input-option"
                              key={"serviceCampaignPulldownSelect"}
                              value={addData.serviceCampaignPulldownName}
                              onChange={(e) => {
                                const serviceCampaignPulldownName = e.target
                                  .value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  serviceCampaignPulldownName,
                                }));
                              }}
                              sx={{
                                height: "30px",
                                textAlign: "end",
                                fontSize: "14px",
                              }}
                            >
                              {selectServiseCampaignPulldownList.map(
                                (service, plan_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuCampaignPulldown" +
                                        plan_i
                                      }
                                      value={service.service_name}
                                      sx={{
                                        fontSize: "14px",
                                        height:
                                          service.service_name === ""
                                            ? "14px"
                                            : "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {service.service_name}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </Select>
                          </FormControl>
                        </Box>
                      </Box>
                    ) : null}
                    {selectServiseCampaignCheckboxList.length > 0 ? (
                      <Box key="contractServiceContent">
                        <Box className="serch-label">
                          {selectServiseCampaignPulldownList.length > 0
                            ? "キャンペーン2"
                            : "キャンペーン"}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          {selectServiseCampaignCheckboxList.map((service) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={
                                    addData.serviceCampaignCheckboxName.findIndex(
                                      (serviceName) =>
                                        serviceName === service.service_name,
                                    ) > -1
                                  }
                                  onClick={() => {
                                    let serviceCampaignCheckboxName =
                                      addData.serviceCampaignCheckboxName.concat();

                                    if (
                                      addData.serviceCampaignCheckboxName.findIndex(
                                        (serviceName) =>
                                          serviceName === service.service_name,
                                      ) > -1
                                    ) {
                                      serviceCampaignCheckboxName =
                                        serviceCampaignCheckboxName.filter(
                                          (serviceName) =>
                                            serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      serviceCampaignCheckboxName.push(
                                        service.service_name,
                                      );
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      serviceCampaignCheckboxName,
                                    }));
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    ) : null}
                    <Box className="serch-label">支払方法</Box>
                    {selectServisePaymentList.length > 0 ? (
                      <Box key="servicePaymentBox1">
                        <FormControl
                          fullWidth
                          sx={{
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          <Select
                            labelId="serch-input-label"
                            id="serch-input-option"
                            key={"servicePaymentSelect"}
                            value={addData.servicePaymentMethodName}
                            onChange={(e) => {
                              const servicePaymentMethodName = e.target
                                .value as string;
                              setAddData((addData) => ({
                                ...addData,
                                servicePaymentMethodName,
                              }));
                            }}
                            sx={{
                              height: "30px",
                              textAlign: "end",
                              fontSize: "14px",
                            }}
                          >
                            {selectServisePaymentList.map((payment, plan_i) => {
                              return (
                                <MenuItem
                                  key={"tableColumnKomokuPlan" + plan_i}
                                  value={payment.payment_method}
                                  sx={{
                                    fontSize: "14px",
                                    height:
                                      payment.payment_method === ""
                                        ? "14px"
                                        : "24px",
                                    minHeight: "auto",
                                  }}
                                >
                                  {payment.payment_method}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                    ) : (
                      <Box key="servicePaymentBox2">
                        <CustomTextField
                          id="textFieldIdPaymentMethod"
                          size="small"
                          value={addData.servicePaymentMethodName}
                          onChange={async (e) => {
                            setAddData((addData) => ({
                              ...addData,
                              servicePaymentMethodName: e.target.value,
                            }));
                          }}
                          sx={{
                            width: "calc(100% - 10px)",
                            margin: "10px 5px",
                          }}
                        />
                        <FormHelperText
                          id="serch-name"
                          sx={{
                            width: "calc(100% - 10px)",
                            textAlign: "right",
                            marginTop: "-8px",
                            marginRight: "5px",
                            height: "25px",
                          }}
                        >
                          ※任意
                        </FormHelperText>
                      </Box>
                    )}
                  </>
                ) : addData.outSiteEntry === 1 ? (
                  <>
                    <Box key="outsideMessageType">
                      <Box className="serch-label">外部URL共有方法</Box>
                      <Box key="outsideMessageType1">
                        <FormControl
                          fullWidth
                          sx={{
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          <Select
                            labelId="serch-input-label"
                            id="serch-input-option"
                            key={"outsideMessageTypeID"}
                            value={addData.outsideMessageType}
                            onChange={(e) => {
                              const outsideMessageType = e.target
                                .value as number;
                              setAddData((addData) => ({
                                ...addData,
                                smsMessagePatternID: null,
                                outsideMessageType,
                              }));
                            }}
                            sx={{
                              height: "30px",
                              textAlign: "end",
                              fontSize: "14px",
                            }}
                          >
                            {smsMessagePatterns.length > 0 ? (
                              <MenuItem
                                key={"outsideMessageTypeID_1"}
                                value={0}
                                sx={{
                                  fontSize: "14px",
                                  height: "24px",
                                  minHeight: "auto",
                                }}
                              >
                                SMS送信
                              </MenuItem>
                            ) : null}
                            {mailMessagePatterns.length > 0 ? (
                              <MenuItem
                                key={"outsideMessageTypeID_2"}
                                value={1}
                                sx={{
                                  fontSize: "14px",
                                  height: "24px",
                                  minHeight: "auto",
                                }}
                              >
                                メール送信
                              </MenuItem>
                            ) : null}
                            <MenuItem
                              key={"outsideMessageTypeID_3"}
                              value={2}
                              sx={{
                                fontSize: "14px",
                                height: "24px",
                                minHeight: "auto",
                              }}
                            >
                              QRコード表示
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                    {addData.outsideMessageType === 0 ? (
                      <>
                        <Box key="smsMessagePatternsBox">
                          <Box className="serch-label">SMSメッセージ選択</Box>
                          <Box key="servicePaymentBox1">
                            <FormControl
                              fullWidth
                              sx={{
                                marginTop: "10px",
                                marginBottom: "20px",
                                marginLeft: "5px",
                                width: "calc(100% - 10px)",
                              }}
                            >
                              <Select
                                labelId="serch-input-label"
                                id="serch-input-option"
                                key={"smsMessagePatternID"}
                                value={addData.smsMessagePatternID}
                                onChange={(e) => {
                                  const smsMessagePatternID = e.target
                                    .value as number;
                                  setAddData((addData) => ({
                                    ...addData,
                                    smsMessagePatternID,
                                  }));
                                }}
                                sx={{
                                  height: "30px",
                                  textAlign: "end",
                                  fontSize: "14px",
                                }}
                              >
                                {smsMessagePatterns.map(
                                  (message, message_i) => {
                                    return (
                                      <MenuItem
                                        key={
                                          "tableColumnKomokuPlan" + message_i
                                        }
                                        value={message.id}
                                        sx={{
                                          fontSize: "14px",
                                          height: "24px",
                                          minHeight: "auto",
                                        }}
                                      >
                                        {message.outside_sms_name}
                                      </MenuItem>
                                    );
                                  },
                                )}
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                        {smsMessagePatterns.map((message) => {
                          if (message.id === addData.smsMessagePatternID) {
                            return (
                              <Box key="smsMessageSampleBox">
                                <Box className="serch-label">
                                  SMSメッセージ-送信ID
                                </Box>
                                <CustomTextField
                                  disabled
                                  id="textFieldIdMessageSample"
                                  size="small"
                                  value={message.outside_sms_sender}
                                  sx={{
                                    width: "calc(100% - 10px)",
                                    margin: "10px 5px",
                                  }}
                                />
                                <Box className="serch-label">
                                  SMSメッセージ-サンプル
                                </Box>
                                <CustomTextField
                                  disabled
                                  id="textFieldIdMessageSample"
                                  size="small"
                                  value={message.outside_sms_body}
                                  sx={{
                                    width: "calc(100% - 10px)",
                                    margin: "10px 5px",
                                  }}
                                  multiline
                                  rows={5}
                                />
                              </Box>
                            );
                          }
                        })}
                      </>
                    ) : addData.outsideMessageType === 1 ? (
                      <>
                        <Box key="mailMessagePatternsBox">
                          <Box className="serch-label">メール選択</Box>
                          <Box key="serviceMAilBox1">
                            <FormControl
                              fullWidth
                              sx={{
                                marginTop: "10px",
                                marginBottom: "20px",
                                marginLeft: "5px",
                                width: "calc(100% - 10px)",
                              }}
                            >
                              <Select
                                labelId="serch-input-label"
                                id="serch-input-option"
                                key={"mailMessagePatternID"}
                                value={addData.smsMessagePatternID}
                                onChange={(e) => {
                                  const smsMessagePatternID = e.target
                                    .value as number;
                                  setAddData((addData) => ({
                                    ...addData,
                                    smsMessagePatternID,
                                  }));
                                }}
                                sx={{
                                  height: "30px",
                                  textAlign: "end",
                                  fontSize: "14px",
                                }}
                              >
                                {mailMessagePatterns.map(
                                  (message, message_i) => {
                                    return (
                                      <MenuItem
                                        key={
                                          "tableColumnKomokuPlan" + message_i
                                        }
                                        value={message.id}
                                        sx={{
                                          fontSize: "14px",
                                          height: "24px",
                                          minHeight: "auto",
                                        }}
                                      >
                                        {message.outside_sms_name}
                                      </MenuItem>
                                    );
                                  },
                                )}
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                        {mailMessagePatterns.map((message) => {
                          if (message.id === addData.smsMessagePatternID) {
                            return (
                              <Box key="mailMessageSampleBox">
                                <Box className="serch-label">
                                  メール-送信メールアドレス
                                </Box>
                                <CustomTextField
                                  disabled
                                  id="textFieldIdMessageSample"
                                  size="small"
                                  value={message.outside_sms_sender}
                                  sx={{
                                    width: "calc(100% - 10px)",
                                    margin: "10px 5px",
                                  }}
                                />
                                <Box className="serch-label">
                                  メール-タイトル
                                </Box>
                                <CustomTextField
                                  disabled
                                  id="textFieldIdMessageSample"
                                  size="small"
                                  value={message.outside_sms_title}
                                  sx={{
                                    width: "calc(100% - 10px)",
                                    margin: "10px 5px",
                                  }}
                                />
                                <Box className="serch-label">メール-本文</Box>
                                <CustomTextField
                                  disabled
                                  id="textFieldIdMessageSample"
                                  size="small"
                                  value={message.outside_sms_body}
                                  sx={{
                                    width: "calc(100% - 10px)",
                                    margin: "10px 5px",
                                  }}
                                  multiline
                                  rows={5}
                                />
                              </Box>
                            );
                          }
                        })}
                      </>
                    ) : null}
                    {outSidePullDownServiceNameList.length > 0 ? (
                      <Box key="pullDowmServiceName">
                        <Box className="serch-label">
                          サービス（プルダウン）
                        </Box>
                        <Box key="pullDowmServiceName1">
                          <FormControl
                            fullWidth
                            sx={{
                              marginTop: "10px",
                              marginBottom: "20px",
                              marginLeft: "5px",
                              width: "calc(100% - 10px)",
                            }}
                          >
                            <Select
                              labelId="serch-input-label"
                              id="serch-input-option"
                              key={"pullDowmServiceNameID"}
                              value={addData.pullDownServiceName}
                              onChange={(e) => {
                                const pullDownServiceName = e.target
                                  .value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  pullDownServiceName,
                                }));
                              }}
                              sx={{
                                height: "30px",
                                textAlign: "end",
                                fontSize: "14px",
                              }}
                            >
                              {outSidePullDownServiceNameList.map(
                                (service, i) => {
                                  return (
                                    <MenuItem
                                      key={"pullDowmServiceNameID_" + i}
                                      value={service.service_name}
                                      sx={{
                                        fontSize: "14px",
                                        height: "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {service.service_name}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </Select>
                          </FormControl>
                        </Box>
                      </Box>
                    ) : null}
                    {outSideCheckBoxServiceNameList.length > 0 ? (
                      <Box key="contractServiceContent">
                        <Box className="serch-label">
                          サービス（チェックボックス）
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "5px",
                            width: "calc(100% - 10px)",
                          }}
                        >
                          {outSideCheckBoxServiceNameList.map((service) => {
                            return (
                              <Box
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-5px",
                                  }}
                                  checked={addData.checkBoxServiceNames
                                    .split(",")
                                    .includes(service.service_name)}
                                  onClick={() => {
                                    let checkBoxServiceNamesArray =
                                      addData.checkBoxServiceNames.split(",");
                                    if (
                                      checkBoxServiceNamesArray.includes(
                                        service.service_name,
                                      )
                                    ) {
                                      checkBoxServiceNamesArray =
                                        checkBoxServiceNamesArray.filter(
                                          (_serviceName) =>
                                            _serviceName !==
                                            service.service_name,
                                        );
                                    } else {
                                      checkBoxServiceNamesArray.push(
                                        service.service_name,
                                      );
                                    }
                                    const checkBoxServiceNames =
                                      checkBoxServiceNamesArray.join(",");
                                    setAddData((addData) => ({
                                      ...addData,
                                      checkBoxServiceNames,
                                    }));
                                  }}
                                />
                                {service.service_name}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    ) : null}
                  </>
                ) : null}

                <Box className="serch-label">リストID</Box>
                <Box key="serviceListIDBox">
                  <CustomTextField
                    id="textFieldIdListID"
                    size="small"
                    value={addData.serviseCustomerListID}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        serviseCustomerListID: e.target.value,
                      }));
                    }}
                    sx={{
                      width: "calc(100% - 10px)",
                      margin: "10px 5px",
                    }}
                  />
                  <FormHelperText
                    id="serch-name"
                    sx={{
                      width: "calc(100% - 10px)",
                      textAlign: "right",
                      marginTop: "-8px",
                      marginRight: "5px",
                      height: "25px",
                    }}
                  >
                    ※任意
                  </FormHelperText>
                </Box>
                {addData.outSiteEntry === 1 &&
                addData.outsideMessageType === 1 &&
                useMailAddressFlg === false ? (
                  <>
                    <Box className="serch-label">
                      メールアドレス（メール送信用）
                    </Box>
                    <InputFreeTextMailAddress
                      addData={addData}
                      setAddData={setAddData}
                      uniqueOption={{
                        option_name: "メールアドレス",
                      }}
                      addressOptionName={addressOptionName}
                    />
                  </>
                ) : null}
                {uniqueOptinList.map((uniqueOption, option_i) => {
                  const option_selects = uniqueOption.option_select as string[];
                  let option_view = false;
                  if (addData.outSiteEntry == 0) {
                    const service_plan_names =
                      uniqueOption.service_plan_names as string[];
                    const service_content_names =
                      uniqueOption.service_content_names as string[];
                    const depend_option_name =
                      uniqueOption.depend_option_name as string;
                    const depend_select_names =
                      uniqueOption.depend_select_names as string[];
                    const depend_option_value =
                      addData.customerInfo[depend_option_name];
                    option_view =
                      (service_plan_names.length === 0 ||
                        service_plan_names.includes(addData.servicePlanName)) &&
                      (service_content_names.length === 0 ||
                        service_content_names.some((item) =>
                          addData.serviceContentNameList.includes(item),
                        )) &&
                      (depend_option_name === "他質問に依存しない" ||
                        (typeof depend_option_value === "string" &&
                          depend_select_names.includes(
                            depend_option_value as string,
                          )) ||
                        (typeof depend_option_value === "object" &&
                          depend_select_names.some((item) =>
                            depend_option_value.includes(item),
                          )));
                  } else if (addData.outSiteEntry == 1) {
                    option_view = true;
                  }
                  if (option_view) {
                    return (
                      <Box key={"optionBox_" + option_i}>
                        <Box className="serch-label">
                          {uniqueOption.option_name}
                        </Box>
                        {uniqueOption.option_type === 0 ? (
                          uniqueOption.tel_flg === 1 ? (
                            <InputFreeTextTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.name_flg === 1 ? (
                            <InputFreeTextName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.company_name_flg === 1 ? (
                            <InputFreeTextCompanyName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.zip_code_flg === 1 ? (
                            <InputFreeTextZipCode
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.space_flg === 1 ? (
                            <InputFreeTextSpace
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.mail_address_flg === 1 ? (
                            <InputFreeTextMailAddress
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.form_tel_flg === 1 ? (
                            <InputFreeTextFormTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (uniqueOption.half_width_number_flg || 0) === 1 ? (
                            <InputFreeTextHalfWidthNumber
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (
                            <InputFreeText
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          )
                        ) : uniqueOption.option_type === 1 ? (
                          <FormControl
                            fullWidth
                            sx={{
                              marginTop: "10px",
                              marginLeft: "5px",
                              width: "calc(100% - 10px)",
                            }}
                          >
                            <Select
                              labelId="serch-input-label"
                              id="serch-input-option"
                              key={"tableColumnKomokuDataSelect" + option_i}
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={(e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                              sx={{
                                height: "30px",
                                textAlign: "end",
                                fontSize: "14px",
                              }}
                            >
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuMenuItem" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                      value={option_select}
                                      sx={{
                                        fontSize: "14px",
                                        height:
                                          option_select === ""
                                            ? "14px"
                                            : "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {option_select}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </Select>
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 20px)",
                                textAlign: "right",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {addData.outSiteEntry === 0
                                ? uniqueOption.required_optional === 1
                                  ? "※必須"
                                  : "※任意"
                                : addData.outSiteEntry === 1
                                  ? (addData.outsideMessageType === 0 &&
                                      uniqueOption.tel_flg === 1) ||
                                    (addData.outsideMessageType === 1 &&
                                      uniqueOption.mail_address_flg === 1)
                                    ? "※必須"
                                    : uniqueOption.outside_form_display === 1
                                      ? "外部ET非表示"
                                      : undefined
                                  : undefined}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 20px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </FormControl>
                        ) : uniqueOption.option_type === 2 ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "10px",
                              marginBottom: "20px",
                              marginLeft: "5px",
                              width: "calc(100% - 10px)",
                            }}
                          >
                            {option_selects.map(
                              (option_select: string, select_i) => {
                                const customerInfoList = addData.customerInfo[
                                  uniqueOption.option_name as string
                                ] as string[];
                                return (
                                  <Box
                                    key={
                                      "tableColumnKomokuDataBox" +
                                      option_i +
                                      "_" +
                                      select_i
                                    }
                                    sx={{ marginRight: "25px" }}
                                  >
                                    <Checkbox
                                      checked={
                                        customerInfoList.findIndex(
                                          (_option_select) =>
                                            _option_select === option_select,
                                        ) > -1
                                      }
                                      onClick={() => {
                                        let _customerInfoList =
                                          customerInfoList.concat();
                                        if (
                                          customerInfoList.findIndex(
                                            (_option_select) =>
                                              _option_select === option_select,
                                          ) > -1
                                        ) {
                                          _customerInfoList =
                                            _customerInfoList.filter(
                                              (_option_select) =>
                                                _option_select !==
                                                option_select,
                                            );
                                        } else {
                                          _customerInfoList.push(option_select);
                                        }
                                        let customerInfo = addData.customerInfo;
                                        customerInfo[
                                          uniqueOption.option_name as string
                                        ] = _customerInfoList;
                                        setAddData((addData) => ({
                                          ...addData,
                                          customerInfo,
                                        }));
                                      }}
                                      sx={{
                                        "& .MuiSvgIcon-root": { fontSize: 16 },
                                        marginTop: "-5px",
                                      }}
                                    />
                                    {option_select}
                                  </Box>
                                );
                              },
                            )}
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 6px)",
                                textAlign: "right",
                                marginTop: "-2px",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {addData.outSiteEntry === 0
                                ? uniqueOption.required_optional === 1
                                  ? "※必須"
                                  : "※任意"
                                : addData.outSiteEntry === 1
                                  ? (addData.outsideMessageType === 0 &&
                                      uniqueOption.tel_flg === 1) ||
                                    (addData.outsideMessageType === 1 &&
                                      uniqueOption.mail_address_flg === 1)
                                    ? "※必須"
                                    : uniqueOption.outside_form_display === 1
                                      ? "外部ET非表示"
                                      : undefined
                                  : undefined}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 6px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </Box>
                        ) : uniqueOption.option_type === 3 ? (
                          <>
                            <CustomTextField
                              id="textFieldIdDate"
                              size="small"
                              type="date"
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={async (e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px",
                              }}
                            />
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 10px)",
                                textAlign: "right",
                                marginTop: "-8px",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {addData.outSiteEntry === 0
                                ? uniqueOption.required_optional === 1
                                  ? "※必須"
                                  : "※任意"
                                : addData.outSiteEntry === 1
                                  ? (addData.outsideMessageType === 0 &&
                                      uniqueOption.tel_flg === 1) ||
                                    (addData.outsideMessageType === 1 &&
                                      uniqueOption.mail_address_flg === 1)
                                    ? "※必須"
                                    : uniqueOption.outside_form_display === 1
                                      ? "外部ET非表示"
                                      : undefined
                                  : undefined}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 10px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 4 ? (
                          <>
                            <input
                              id="textFieldPicture"
                              type="file"
                              onChange={(
                                event_file: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                if (
                                  event_file.target.files &&
                                  event_file.target.files.length > 0
                                ) {
                                  const file = event_file.target.files[0];
                                  const updatedPostPictures = {
                                    ...postPictures,
                                    [uniqueOption.option_name as string]: file,
                                  };
                                  setPostPicture(updatedPostPictures);
                                }
                              }}
                            />
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 10px)",
                                textAlign: "right",
                                marginTop: "-8px",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {addData.outSiteEntry === 0
                                ? uniqueOption.required_optional === 1
                                  ? "※必須"
                                  : "※任意"
                                : addData.outSiteEntry === 1
                                  ? (addData.outsideMessageType === 0 &&
                                      uniqueOption.tel_flg === 1) ||
                                    (addData.outsideMessageType === 1 &&
                                      uniqueOption.mail_address_flg === 1)
                                    ? "※必須"
                                    : uniqueOption.outside_form_display === 1
                                      ? "外部ET非表示"
                                      : undefined
                                  : undefined}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 10px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </>
                        ) : null}
                      </Box>
                    );
                  }
                })}
              </Box>
            </Paper>
            <Box
              key="contract7"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  disabled={!onPostBottun}
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={postAddContractData}
                >
                  <Box
                    className="m-plus-rounded-1c-regular"
                    style={{
                      color: !onPostBottun ? "rgb(70 70 70)" : undefined,
                    }}
                  >
                    {addData.outSiteEntry === 0
                      ? "新規登録"
                      : addData.outsideMessageType === null ||
                          addData.outsideMessageType === 0
                        ? "SMS送信"
                        : addData.outsideMessageType === 1
                          ? "メール送信"
                          : addData.outsideMessageType === 2
                            ? "QRコード表示"
                            : "SMS送信"}
                  </Box>
                  {addData.outSiteEntry === 0 ? (
                    <AddCircleOutlineIcon
                      sx={{
                        marginLeft: "6px",
                        color: !onPostBottun ? "rgb(70 70 70)" : "white",
                      }}
                      fontSize="medium"
                    />
                  ) : (
                    <EmailIcon
                      sx={{
                        marginLeft: "6px",
                        color: !onPostBottun ? "rgb(70 70 70)" : "white",
                      }}
                      fontSize="medium"
                    />
                  )}
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "product",
                      productId: null,
                      productName: "",
                      have_entry_form: null,
                      servicePlanName: "",
                      serviceContentNameList: [],
                      serviceCampaignPulldownName: "",
                      serviceCampaignCheckboxName: [],
                      servicePaymentMethodName: "",
                      serviseCustomerListID: "",
                      pullDownServiceName: "",
                      checkBoxServiceNames: "",
                      smsMessagePatternID: null,
                      customerInfo: {},
                    }));
                    setSelectServisePlanList([]);
                    setSelectServiseContentList([]);
                    setSelectServiseCampaignPulldownList([]);
                    setSelectServiseCampaignCheckboxList([]);
                    setSelectServisePaymentList([]);
                    setUniqueOptinList([]);
                    setAddressOptionName("");
                    setOutSidePullDownServiceNameList([]);
                    setOutSideCheckBoxServiceNameList([]);
                    setSmsMessagePatterns([]);
                    setMailMessagePatterns([]);
                    setUseMailAddressFlg(false);
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : addData.addStatus === "sms_success" ? (
          <>
            <Typography
              id="modal-modal-description"
              sx={{
                mt: 0,
                mb: 5,
                maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 150px)",
                overflowY: windowWidth > 385 ? undefined : "auto",
              }}
              key="ClosingTossUpModalBoxProject"
            >
              <Paper elevation={0}>
                <Box
                  key="shozai1"
                  sx={{
                    maxHeight:
                      windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                    overflowY: windowWidth > 385 ? "auto" : undefined,
                  }}
                >
                  <Box
                    className="shippori-antique-regular"
                    key="sms_success"
                    sx={{ marginTop: "15px", marginBottom: "5px" }}
                  >
                    {addData.outsideMessageType === 0
                      ? "SMSを送信しました。"
                      : addData.outsideMessageType === 1
                        ? "メールを送信しました。"
                        : addData.outsideMessageType === 2
                          ? "QRコードを表示します。"
                          : ""}
                  </Box>
                  <Box
                    className="shippori-antique-regular"
                    key="sms_success"
                    sx={{
                      marginTop: "25px",
                      marginBottom: "5px",
                      textAlign: "center",
                      display: windowWidth > 500 ? "flex" : undefined,
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "center",
                        width:
                          windowWidth > 385
                            ? 200
                            : windowWidth > 250
                              ? 180
                              : 140,
                        marginLeft:
                          addData.viewOutsideServiceUrl === 1
                            ? windowWidth > 500
                              ? "calc(50% - 210px - 2.5%)"
                              : "auto"
                            : "auto",
                        marginRight:
                          addData.viewOutsideServiceUrl === 1
                            ? windowWidth > 500
                              ? undefined
                              : "auto"
                            : "auto",
                      }}
                    >
                      <Box>
                        エントリーページ
                        <IconButton
                          sx={{
                            height: "25px",
                            width: "25px",
                            marginBottom: "5px",
                          }}
                          aria-label="detail row"
                          size="medium"
                          onClick={() => {
                            const canvas = document.querySelector("canvas");
                            const link = document.createElement("a");
                            if (canvas) {
                              link.href = canvas.toDataURL("image/png");
                              link.download = "qrcode.png";
                              link.click();
                            }
                          }}
                        >
                          <FileDownloadIcon fontSize="medium" />
                        </IconButton>
                      </Box>
                      <Box>
                        <QRCodeCanvas
                          value={addData.outsideSiteUrl}
                          size={
                            windowWidth > 385
                              ? 200
                              : windowWidth > 250
                                ? 180
                                : 140
                          }
                        />
                      </Box>
                    </Box>
                    {addData.viewOutsideServiceUrl === 1 ? (
                      <Box
                        sx={{
                          textAlign: "center",
                          width:
                            windowWidth > 385
                              ? 200
                              : windowWidth > 250
                                ? 180
                                : 140,
                          marginLeft:
                            windowWidth > 500 ? "calc(10px + 5%)" : "auto",
                          marginRight: windowWidth > 500 ? undefined : "auto",
                          marginTop: windowWidth > 500 ? undefined : "25px",
                        }}
                      >
                        <Box>
                          サービスページ
                          <IconButton
                            sx={{
                              height: "25px",
                              width: "25px",
                              marginBottom: "5px",
                            }}
                            aria-label="detail row"
                            size="medium"
                            onClick={() => {
                              const canvas = document.querySelector("canvas");
                              const link = document.createElement("a");
                              if (canvas) {
                                link.href = canvas.toDataURL("image/png");
                                link.download = "qrcode.png";
                                link.click();
                              }
                            }}
                          >
                            <FileDownloadIcon fontSize="medium" />
                          </IconButton>
                        </Box>
                        <Box>
                          <QRCodeCanvas
                            value={addData.outsideServiceUrl}
                            size={
                              windowWidth > 385
                                ? 200
                                : windowWidth > 250
                                  ? 180
                                  : 140
                            }
                          />
                        </Box>
                      </Box>
                    ) : null}
                  </Box>
                  <Box
                    className="shippori-antique-regular"
                    key="sms_success"
                    sx={{
                      marginTop: "45px",
                      marginBottom: "5px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                    }}
                  >
                    エントリーページ: <br />
                    {addData.outsideSiteUrl}
                  </Box>
                  {addData.viewOutsideServiceUrl === 1 ? (
                    <Box
                      className="shippori-antique-regular"
                      key="sms_success"
                      sx={{
                        marginTop: "30px",
                        marginBottom: "5px",
                        wordWrap: "break-word",
                        wordBreak: "break-all",
                      }}
                    >
                      サービスページ: <br />
                      {addData.outsideServiceUrl}
                    </Box>
                  ) : null}
                </Box>
              </Paper>
            </Typography>
            <Box
              key="shozaiSelect"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "contract",
                    }));
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">入力に戻る</Box>
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </Box>
          </>
        ) : null}
      </Box>
    </Modal>
  ) : null;
}
